/* eslint-disable @typescript-eslint/no-explicit-any */
import { Group } from '../../../types/shared/Group';

type FieldSet<T> = {
  // If the group is null then this set doesn't correspond to any group.
  group: Group | null | undefined;
  children: Array<T>;
};

function getFieldID(field: { [key: string]: any }): string {
  return typeof field.id === 'string' ? field.id : '';
}

function getFieldSets<
  T extends {
    [key: string]: any;
  }
>(groups: Array<Group>, fields: Array<T>): Array<FieldSet<T>> {
  let fieldSets: Array<FieldSet<T>> = [];

  let createFieldSet = (group: Group | null) => {
    let newGroup = { group, children: [] };
    fieldSets.push(newGroup);
    return newGroup;
  };

  let getGroupForField = (field: T) => {
    // Get the index of the first group that contains this field.
    let group = groups.find((g) => g.fields.indexOf(getFieldID(field)) !== -1);
    // If this field does not belong to any group, create a new field set.
    if (group == null) {
      return createFieldSet(null);
    }
    // Find the field set that corresponds to this group (or create a new one).
    return (
      fieldSets.find((set) => set.group === group) || createFieldSet(group)
    );
  };

  fields.forEach((field) => {
    let group = getGroupForField(field);
    group.children.push(field);
  });

  return fieldSets;
}

export default getFieldSets;
